import UICheckboxFilterBlock, {CheckboxFilterBlock} from "./filter/UICheckboxFilterBlock";
import UISelectFilterBlock, {SelectFilterBlock} from "./filter/UISelectFilterBlock";
import PrimaryButton from "../PrimaryButton";
import TextButton from "../TextButton";
import React, {useState} from "react";
import {FilterBlock, FilterBlockType, FilterState} from "./TableFilter";
import UIRadioFilterBlock, {RadioFilterBlock} from "./filter/UIRadioFilterBlock";

type Props = {
  filters: FilterBlock[];
  states: FilterState[];
  onApply: (states: FilterState[]) => void
}

export default function TableFilterPanel({filters, states, onApply}: Props) {
  const [localFilterStates, setLocalFilterStates] = useState(states);

  const isApplyActive = () => {
    if (states.length !== localFilterStates.length) {
      return true;
    }
    const sortedStates = states.sort((x, y) => x.id.localeCompare(y.id));
    const sortedLocalStates = localFilterStates.sort((x, y) => x.id.localeCompare(y.id));
    return !sortedStates.every((left: FilterState, index: number) => {
      const right = sortedLocalStates[index];
      return left.id === right.id && left.value === right.value && left.active === right.active;
    })
  };

  const updateState = (f: FilterState) => {
    const index = localFilterStates.findIndex(x => x.id === f.id);
    if (index < 0) {
      return;
    }
    setLocalFilterStates(localFilterStates.map(x => x.id === f.id ? f : x));
  }

  const isCheckboxFilter = (filter: FilterBlock): filter is CheckboxFilterBlock => filter.type === FilterBlockType.CHECKBOX;
  const isSelectFilter = (filter: FilterBlock): filter is SelectFilterBlock => filter.type === FilterBlockType.SELECT;
  const isRadioFilter = (filter: FilterBlock): filter is RadioFilterBlock => filter.type === FilterBlockType.RADIO;

  const withStates = filters.map(f => ({
    filter: f,
    state: localFilterStates.find(s => s.id === f.id) || new FilterState(f.id, false, '')
  }));

  return (
    <>
      {withStates.map(entity => (
        <div key={entity.filter.id}>
          {isCheckboxFilter(entity.filter) &&
            <UICheckboxFilterBlock data={entity.filter} onToggle={updateState} state={entity.state}/>
          }
          {isSelectFilter(entity.filter) &&
            <UISelectFilterBlock data={entity.filter} onToggle={updateState} state={entity.state}/>
          }
          {isRadioFilter(entity.filter) &&
            <UIRadioFilterBlock data={entity.filter} onToggle={updateState} state={entity.state}/>
          }
        </div>
      ))}
      <div className="py-2 flex px-3 border-gray-light border-t">
        <PrimaryButton onClick={() => onApply(localFilterStates)} short={true} className="mr-4"
                       disabled={!isApplyActive()}>Apply</PrimaryButton>
        <TextButton onClick={() => setLocalFilterStates(localFilterStates.map(x => x.reset()))}
                    short={true}>Clear</TextButton>
      </div>
    </>
  )
}
